import script from "./OrderPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderPayment.vue?vue&type=script&setup=true&lang=js"

import "./OrderPayment.vue?vue&type=style&index=0&id=a6b38c62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6b38c62"]])

export default __exports__